/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-key */
import React, { BaseSyntheticEvent, FC, useEffect, useRef, useState } from 'react'
import { fetchCrews } from './utils'
import i18n from 'live/services/i18n'
import LiveSelect from 'live/components/forms/ui/select'

interface SelectorProps extends AssetSelectorBaseProps {
    crew?: any,
}

export const CrewSelector: FC<SelectorProps> = ({ onChange, crew, mode, label, placeholder, required, readOnly, validationState }) => {
    const [crews, setCrews] = useState<any[]>([])
    const [selectedCrew, setSelectedCrew] = useState<any>(crew)

    const selectCrew = (e: BaseSyntheticEvent, data: unknown): void => {
        if (onChange) onChange(data)
        setSelectedCrew(data)
    }

    const buildLabel = () => {
        return `${ label ?? i18n('Crews') } ${ required ? '*': '' }`
    }

    useEffect(() => {
        fetchCrews().then(response => {
            const responseArray = Object.entries(response).map(e => e[1])
            const crews = [
                ...responseArray.map(crew => ({
                    value: crew.name,
                    label: crew.name,
                    data: {
                        id: crew.id,
                        name: crew.name
                    }
                }))
            ]
            setCrews(crews)
        })
    }, []);

    return (
        <>
            <LiveSelect
                clearable={true}
                label={buildLabel()}
                options={crews}
                disabled={readOnly || mode === 'readOnly'}
                onBlur={() => {}}
                onChange={selectCrew}
                placeholder={placeholder ?? i18n('Select a crew')}
                value={mode === 'edit' || mode === 'readOnly'? selectedCrew : undefined}
                validationState={validationState}
            />
        </>
    )
}